import { useQuery } from "@tanstack/react-query";
import { fetchInitialData } from "../../apis/siteData";
import { useDispatch } from "react-redux";

export const useFetchInitialSiteData = ()=>{
    return useQuery({
        queryKey: ['initial_site_data'],
        queryFn: () => fetchInitialData(), 
        onError: (error) => {
          console.error("Error Fetching Initial Data!", error);
        },
      });
}